const EMPTY_APPS = Object.freeze([]);
const INITIAL = {
    accessToken: null,
    user: null,
    allowedApps: EMPTY_APPS,
};
let state = INITIAL;
const subscribers = new Set();
function notify() {
    for (const listener of subscribers)
        listener();
}
/** @internal — selectors read this. */
export function getState() {
    return state;
}
/** @internal — `doRefresh` mutates this on success. */
export function setAccessToken(token) {
    if (state.accessToken === token)
        return;
    state = { ...state, accessToken: token };
    notify();
}
/** @internal — `bootstrap` mutates this after `/v1/me` returns. */
export function setMe(user, allowedApps) {
    state = { ...state, user, allowedApps };
    notify();
}
/** @internal — `logout` and refresh-failure clear the state. */
export function clearState() {
    if (state === INITIAL)
        return;
    state = INITIAL;
    notify();
}
/**
 * Subscribe to state changes. Listeners are invoked with no arguments —
 * re-read state via the public selectors. Returns an unsubscribe function.
 * Compatible with React's `useSyncExternalStore(subscribe, getSnapshot)`.
 */
export function subscribe(listener) {
    subscribers.add(listener);
    return () => {
        subscribers.delete(listener);
    };
}
/** @internal — for tests. */
export function _resetState() {
    state = INITIAL;
    subscribers.clear();
}
/** @internal — for tests / debugging. */
export function _subscriberCount() {
    return subscribers.size;
}
//# sourceMappingURL=state.js.map